// extracted by mini-css-extract-plugin
export default {"button":"Btn_button__iMbY9","primary":"Btn_primary__z3eHq","secondary":"Btn_secondary__cIXZe","formbutton":"Btn_formbutton__+rp1n"};